export function NumberTypes(type) {
  let number_type = '中国居民身份证';
  switch (type) {
    case "id_number" : number_type='中国居民身份证';break;
    case "idTypeCode_HMT" : number_type='港澳台居民居住证';break;
    case "idTypeCode_wgjzz" : number_type='外国人永久居留身份证';break;
    case "HM" : number_type='港澳居民来往内地通行证';break;
    case "TAI" : number_type='台湾居民来往大陆通行证';break;
    case "passport" : number_type='护照（仅国外教练员使用）';break;
  }
  return number_type;
}

export function  uuid() {
    let s = [];
    const hexDigits = "0123456789abcdef";
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "";

    return s.join("")
}

export const country = {
  "CN": "中国",
  "AD": "安道尔",
  "AE": "阿闻酋",
  "AF": "阿富汗",
  "AG": "安提瓜和巴布达",
  "AI": "安圭拉",
  "AL": "阿尔巴尼亚",
  "AM": "亚美尼亚",
  "AN": "荷属安的列斯",
  "AO": "安哥拉",
  "AQ": "南极洲",
  "AR": "阿根廷",
  "AS": "美属萨摩亚",
  "AT": "奥地利",
  "AU": "澳大利亚",
  "AW": "阿鲁巴",
  "AZ": "阿塞拜疆",
  "BA": "波斯尼亚和黑塞哥维那",
  "BB": "巴巴多斯",
  "BD": "孟加拉国",
  "BE": "比利时",
  "BF": "布基纳法索",
  "BG": "保加利亚",
  "BH": "巴林",
  "BI": "布隆迪",
  "BJ": "贝宁",
  "BL": "聖巴托洛繆島",
  "BM": "百慕大",
  "BN": "文莱",
  "BO": "玻利维亚",
  "BR": "巴西",
  "BS": "巴哈马",
  "BT": "不丹",
  "BW": "博茨瓦纳",
  "BY": "白俄罗斯",
  "BZ": "伯利兹",
  "CA": "加拿大",
  "CC": "科科斯(基林)群岛",
  "CD": "刚果民主共和",
  "CF": "中非",
  "CG": "刚果",
  "CH": "瑞士",
  "CI": "科特迪瓦",
  "CK": "库克群岛",
  "CL": "智利",
  "CM": "喀麦隆",
  "CO": "哥伦比亚",
  "CR": "哥斯达黎加",
  "CU": "古巴",
  "CV": "佛得角",
  "CX": "圣诞岛",
  "CY": "塞浦路斯",
  "CZ": "捷克",
  "DE": "德国",
  "DJ": "吉布提",
  "DK": "丹麦",
  "DM": "多米尼克",
  "DO": "多米尼加共和国",
  "DZ": "阿尔及利亚",
  "EC": "厄瓜多尔",
  "EE": "爱沙尼亚",
  "EG": "埃及",
  "EH": "西撒哈拉",
  "ER": "厄立特里亚",
  "ES": "西班牙",
  "ET": "埃塞俄比亚",
  "FI": "芬兰",
  "FJ": "斐济",
  "FK": "马尔维纳斯群岛(福克兰群岛)",
  "FM": "密克罗尼西亚",
  "FO": "法罗群岛",
  "FR": "法国",
  "GA": "加蓬",
  "GB": "英国",
  "GD": "格林纳达",
  "GE": "格鲁吉亚",
  "GF": "法属圭亚那",
  "GG": "根西岛",
  "GH": "加纳",
  "GI": "直布罗陀",
  "GL": "格陵兰",
  "GM": "冈比亚",
  "GN": "几内亚",
  "GP": "瓜德罗普",
  "GQ": "赤道几内亚",
  "GR": "希腊",
  "GS": "南乔治亚岛和南桑德韦奇岛",
  "GT": "危地马拉",
  "GU": "关岛",
  "GW": "几内亚比绍",
  "GY": "圭亚那",
  "HN": "洪都拉斯",
  "HR": "克罗地亚",
  "HT": "海地",
  "HU": "匈牙利",
  "ID": "印度尼西亚",
  "IE": "爱尔兰",
  "IL": "以色列",
  "IM": "曼島",
  "IN": "印度",
  "IO": "英属印度洋领土",
  "IQ": "伊拉克",
  "IR": "伊朗",
  "IS": "冰岛",
  "IT": "意大利",
  "JE": "澤西島",
  "JM": "牙买加",
  "JO": "约旦",
  "JP": "日本",
  "KE": "肯尼亚",
  "KG": "吉尔吉斯斯坦",
  "KH": "柬埔寨",
  "KI": "基里巴斯",
  "KM": "科摩罗",
  "KN": "圣基茨和尼维斯",
  "KP": "朝鲜",
  "KR": "韩国",
  "KW": "科威特",
  "KY": "开曼群岛",
  "KZ": "哈萨克斯坦",
  "LA": "老挝",
  "LB": "黎巴嫩",
  "LC": "圣卢西亚",
  "LI": "列支敦士登",
  "LK": "斯里兰卡",
  "LR": "利比里亚",
  "LS": "莱索托",
  "LT": "立陶宛",
  "LU": "卢森堡",
  "LV": "拉脱维亚",
  "LY": "利比亚",
  "MA": "摩洛哥",
  "MC": "摩纳哥",
  "MD": "摩尔多瓦",
  "ME": "蒙特內哥羅",
  "MF": "法屬聖馬丁",
  "MG": "马达加斯加",
  "MH": "马绍尔群岛",
  "MK": "马斯顿",
  "ML": "马里",
  "MM": "缅甸",
  "MN": "蒙古",
  "MP": "北马里亚纳",
  "MQ": "马提尼克",
  "MR": "毛里塔尼亚",
  "MS": "蒙特塞拉特",
  "MT": "马耳他",
  "MU": "毛里求斯",
  "MV": "马尔代夫",
  "MW": "马拉维",
  "MX": "墨西哥",
  "MY": "马来西亚",
  "MZ": "莫桑比克",
  "NA": "纳米比亚",
  "NC": "新喀里多尼亚",
  "NE": "尼日尔",
  "NF": "诺福克岛",
  "NG": "尼日利亚",
  "NI": "尼加拉瓜",
  "NL": "荷兰",
  "NO": "挪威",
  "NP": "尼泊尔",
  "NR": "瑙鲁",
  "NU": "纽埃",
  "NZ": "新西兰",
  "OM": "阿曼",
  "PA": "巴拿马",
  "PE": "秘鲁",
  "PF": "法属波利尼西亚",
  "PG": "巴布亚新几内亚",
  "PH": "菲律宾",
  "PK": "巴基斯坦",
  "PL": "波兰",
  "PM": "圣皮埃尔和密克隆",
  "PN": "皮特凯恩群岛",
  "PR": "波多黎各",
  "PS": "巴勒斯坦",
  "PT": "葡萄牙",
  "PW": "贝劳",
  "PY": "巴拉圭",
  "QA": "卡塔尔",
  "RE": "留尼汪",
  "RO": "罗马尼亚",
  "RS": "塞尔维亚",
  "RU": "俄罗斯",
  "RW": "卢旺达",
  "SA": "沙竺阿拉伯",
  "SB": "所罗门群岛",
  "SC": "塞舌尔",
  "SD": "苏丹",
  "SE": "瑞典",
  "SG": "新加坡",
  "SH": "圣赫勒拿",
  "SI": "斯洛文尼亚",
  "SJ": "斯瓦尔巴群岛",
  "SK": "斯洛伐克",
  "SL": "塞拉利昂",
  "SM": "圣马力诺",
  "SN": "塞内加尔",
  "SO": "索马里",
  "SR": "苏里南",
  "ST": "圣多美和普林西比",
  "SV": "萨尔瓦多",
  "SY": "叙利亚",
  "SZ": "斯威士兰",
  "TC": "特克斯科斯群岛",
  "TD": "乍得",
  "TG": "多哥",
  "TH": "泰国",
  "TJ": "塔吉克斯坦",
  "TK": "托克劳",
  "TL": "东帝汶",
  "TM": "土库曼斯坦",
  "TN": "突尼斯",
  "TO": "汤加",
  "TR": "土耳其",
  "TT": "特立尼达和多巴哥",
  "TV": "图瓦卢",
  "TZ": "坦桑尼亚",
  "UA": "乌克兰",
  "UG": "乌干达",
  "US": "美国",
  "UY": "乌拉圭",
  "UZ": "乌兹别克斯坦",
  "VA": "梵蒂冈",
  "VC": "圣文森特和格林纳丁斯",
  "VE": "委内瑞拉",
  "VG": "英属维尔京群岛",
  "VI": "美属维尔京群岛",
  "VN": "越南",
  "VU": "瓦努阿图",
  "WF": "瓦利斯和富图纳群岛",
  "WS": "西萨摩亚",
  "YE": "也门",
  "YT": "马约特",
  "ZA": "南非",
  "ZM": "赞比亚",
  "ZW": "津巴布韦"
};

export const language = {
  "1": "中文",
  "2": "英语",
  "3": "法语",
  "4": "德语",
  "5": "日语",
  "6": "意大利语",
  "7": "西班牙语",
  "8": "阿萨姆语",
  "9": "艾马拉语",
  "10": "班巴拉语",
  "11": "波斯尼亚语",
  "12": "缅甸语",
  "13": "克罗地亚语",
  "14": "古吉拉特语",
  "15": "海地克里奥尔语",
  "16": "豪萨语",
  "17": "印尼语",
  "18": "爪哇语",
  "19": "卡纳达语",
  "20": "朝鲜语",
  "21": "老挝语",
  "22": "马来语",
  "23": "蒙古语",
  "24": "四川彝语",
  "25": "普什图语",
  "26": "旁遮普语",
  "27": "僧伽罗语",
  "28": "索马里语",
  "29": "塔加洛语",
  "30": "塔吉克语",
  "31": "泰米尔语",
  "32": "泰语",
  "33": "藏语",
  "34": "乌尔都语",
  "35": "越南语",
  "36": "阿塞拜疆语",
  "37": "阿尔巴尼亚语",
  "38": "阿拉伯语",
  "39": "亚美尼亚语",
  "40": "保加利亚语",
  "41": "格鲁吉亚语",
  "42": "丹麦语",
  "43": "希伯来语",
  "44": "现代希腊语",
  "45": "爱沙尼亚语",
  "46": "冰岛语",
  "47": "拉脱维亚语",
  "48": "立陶宛语",
  "49": "孟加拉语",
  "50": "尼泊尔语",
  "51": "挪威语",
  "52": "荷兰语",
  "53": "匈牙利语",
  "54": "乌克兰语",
  "55": "波斯语",
  "56": "波兰语",
  "57": "葡萄牙语",
  "58": "罗马尼亚语",
  "59": "俄语",
  "60": "梵语",
  "61": "塞尔维亚语",
  "62": "马其顿语",
  "63": "斯洛伐克语",
  "64": "斯洛文尼亚语",
  "65": "斯瓦希里语",
  "66": "瑞典语",
  "67": "泰卢固语",
  "68": "土耳其语",
  "69": "捷克语",
  "70": "芬兰语",
  "71": "印地语",
  "72": "高棉语"
};


export function levelFilters(val) {
  let res = '--'
  switch (val) {
    case '0':
      res = '职业级';
      break;
    case 'A':
      res = 'A级';
      break;
    case 'B':
      res = 'B级';
      break;
    case 'C':
      res = 'C级';
      break;
    case 'D':
      res = 'D级';
      break;
  }
  return res;
}

export function debounce(fun, wait, immediate) {
  let timeout;
  return function (...args) {
    let context = this;
    if (timeout) clearTimeout(timeout)
    if (immediate) {
      let callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait)
      if (callNow) fun.apply(context, args)
    } else {
      timeout = setTimeout(function () {
        fun.apply(context, args)
      }, wait)
    }
  }
}
